import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 DER REHA-CODE 360° — SIGMA SMART™',
  ideal: 'Profis und verletzte Personen, die ein klinisches Rehabilitations-System von Grund auf meistern wollen',
  was: '€54',
  now: '27',
  features: ['6 komplette Bände (Hauptinhalt)', 'Schulter-, Knie-, Knöchel-, Wirbelsäulen-, Hüft- & Ellbogenprotokolle', 'Traffic Light System für sichere Progression', 'Load Master Protocol für exakte Laststeigerung', 'A.R.M.A. Präventions-Schild inklusive', '5 Kostenlose Boni — €249 Wert', '7-Tage-Geld-zurück-Garantie'],
  cta: 'Holen Sie sich den Reha-Code 360° jetzt'
};
const trust = [{
  icon: LockIcon,
  label: '100% Sichere Zahlung'
}, {
  icon: ZapIcon,
  label: 'Sofortiger Zugriff'
}, {
  icon: CreditCardIcon,
  label: 'Kreditkarte / Lastschrift'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Preis" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-129" data-mp="4scmsyl1joqz">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-130" data-mp="9rz2deocdh2y">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(193,18,31,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-131" data-mp="eqtjmc6nuxky">
          <h3 className="font-display text-lg font-black text-grape" data-id="element-132" data-mp="2zhashvlbc91t">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-133" data-mp="2zf7t4ky9t3kf">
            <span className="font-semibold text-plum/80" data-id="element-134" data-mp="2rfjy1jrsyyp9">Ideal für:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-135" data-mp="2mh08zahwx6so">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-136" data-mp="2mfp3n68tjqzg">{plan.was}</span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "9px",
            paddingBottom: "9px"
          }} data-id="element-137" data-mp="2w7bf93p2js2q">
              <span className="relative inline-block font-display leading-none" style={{
              fontFamily: "Montserrat, sans-serif"
            }} data-id="element-138" data-mp="28k396jjtgezn">
                {/* Currency symbol — adjust fontSize here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 font-black leading-none" style={{
                fontSize: "40px",
                marginRight: "4px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-139" data-mp="2dh3g0wohplrt">
                  €
                </span>

                {/* Amount — stays centered on the page */}
                <span className="text-grape-shine font-black leading-none" style={{
                fontSize: "70px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-140" data-mp="92fmm62gdps">
                  {plan.now}
                </span>

                {/* Currency code — adjust fontSize here */}
                <span className="absolute left-full top-1/2 -translate-y-1/2 font-bold uppercase leading-none tracking-wide text-grape" style={{
                fontSize: "26px",
                marginLeft: "6px",
                fontWeight: "900",
                fontFamily: "Merriweather, serif"
              }} data-id="element-141" data-mp="3rgyh2ok2nrmw">
                  EUR
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-142" data-mp="e8byjtlnplxg">
              Einmalzahlung · Lebenslanger Zugriff
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-143" data-mp="16qfxfg3yzqep">
              Die Zahlung erfolgt in Euro.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-144" data-mp="3f8bh6fynv5sg">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-145" data-mp="3a7dzs5lh6fs0">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-146" data-mp="358ko8ipr0yuh" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-147" data-mp="319kahem4omec">
            <CTAButton size="md" data-id="element-148" data-mp="1rkktv6slcd2">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-149" data-mp="3sz6vw8vuch3y">
            Sie sparen €222 (89% RABATT)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-150" data-mp="3o6vwd750ixbx">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-151" data-mp="kjwxpbv2nw1g">
                <Icon className="h-4 w-4 text-grape" data-id="element-152" data-mp="fs54suog1e85" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-153" data-mp="1ygpunzy01ywc" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-154" data-mp="1yhhrfe3c22o7">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-155" data-mp="27fjv61egb9f6" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-156" data-mp="2ceo915cblvbu">
            <span className="font-display font-bold text-grape" data-id="element-157" data-mp="2cctldj9nzp42">
              🛡️ 7-Tage-Geld-zurück-Garantie.
            </span>{' '}
            Wenn Sie sich innerhalb der ersten 7 Tage unsicher sind, ob DER REHA-CODE 360° Ihren
            Anforderungen entspricht oder Ihnen den Gesundheitsboost bringt, den Sie erwarten,
            fordern Sie einfach eine Rückerstattung an und wir erstatten Ihnen 100% Ihres Geldes.
            Wir möchten, dass Sie risikofrei rehabilitieren.
          </p>
        </div>
      </div>
    </section>;
}